<!-- <div [hidden]="ifNotRoot" class="scrollable-div" appScrollable (scrollPosition)="scrollHandler($event)">
  <div class="container">
    <div class="_Hejdi listing_wrap">
      <div (click)="goToDetails(list.id, list.user)" class="card _listing" style="width: 18rem; cursor: pointer;"
        *ngFor="let list of paginationService.data | async">
        <div class="card-overlay" *ngIf="list.user === userID">
        </div>
        <div *ngIf="list.images; else noImage" [ngStyle]="getBackgroundImageStyle((list.images[0] | imageUrl) | async)"
          class="card-img-top card-photo"></div>
        <ng-template #noImage>
          <div [ngStyle]="getBackgroundImageStyle(null)" class="card-img-top card-photo"></div>
        </ng-template>

        <div class="card-body">
          <h5 class="card-title">{{ list.name ? list.name : 'No Title' }}</h5>
          <p class="card-text price">${{ list.rentalPrice }} /day</p>
          <p class="card-text location">
            {{ list.location ? list.location : 'No Location' }}
          </p>
          <span class="star_rating" style="width:50px;"></span>
        </div>
      </div>
    </div>
    <p *ngIf="paginationService.done | async">No more results!</p>
    <app-spinner *ngIf="paginationService.loading | async"></app-spinner>
  </div>
</div> -->

<!-- Add scrolling tab with all major category, then sub categgory in filter section -->
<app-skeleton [show]="loading">
  <div [hidden]="ifNotRoot" class="market_listing__wrapper">
    <div class="container-fluid" style="max-width: 100%;">
      <div class="row">
        <div class="col-sm-12 col-xs-12 d-lg-none d-md-none d-sm-flex d-flex filter-sort-block">  
          <button class="rui-btn rui-btn--outline" disabled>
            <!-- Filter -->
            <!-- TODO enable btn and uncomment 'filter', put sortby in next btn -->
            Sort by
          </button>
          <button class="rui-btn rui-btn--outline">
            <!-- Sort -->
            <select class="form-select" [(ngModel)]="sortBy" (ngModelChange)="emitSortBy()" matNativeControl required>
              <option value="0">Popular</option>
              <option value="1">Low to High</option>
              <option value="2">High to Low</option>
            </select>
          </button>
        </div>
        <div class="col-lg-3 col-md-3 d-lg-block d-md-block d-sm-none d-none">
          <div class="filter-section__detail mt-4">
            <mat-form-field appearance="fill">
              <mat-label>Sort by</mat-label>
              <select [(ngModel)]="sortBy" (ngModelChange)="emitSortBy()" matNativeControl required>
                <option value="0">Popular</option>
                <option value="1">Low to High</option>
                <option value="2">High to Low</option>
              </select>
            </mat-form-field>
          </div>
          <section class="filter-section">
            <h6>Filters</h6>
            <hr />
            <div class="filter-section__detail">
              <h6>Price</h6>
              <app-price-min-max-form (applyChange)="emitPriceRange($event)"></app-price-min-max-form>
            </div>
            <!-- TODO: SETUP CATEGORY FILTERING -->
            <!-- <div class="filter-section__detail">
              <h6>Category</h6>
              <ng-container *ngFor="let c of categories">
                <mat-checkbox color="primary" class="example-margin pt-2 pb-2" name="{{ c.source.name }}" id="cat_{{c.source.name}}"
                  [(ngModel)]="c.checked" (change)="categoryChange($event)">{{
                  c.source.name }}</mat-checkbox>
              </ng-container>
            </div> -->
          </section>
        </div>
        <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div class="_Hejdi listing_wrap_results">
            <div class="result_wrap">
              <ng-container class="listing" *ngFor="let list of rentals$ | async">
                <app-listing-item [source]="list" class="app-listing-wrap"></app-listing-item>
              </ng-container>
            </div>
            <!-- <p *ngIf="paginationService.done | async">No more results!</p> -->
            <div class="listing-loding-container" *ngIf="isQueryLoading">
              <img src="../assets/img/loader.gif" />
              <span>Searching for more.......</span>
            </div>

            <div class="no-more-data" *ngIf="hasNoMoreResults">
              <hr />
              <sub>No more items to load</sub>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-skeleton>

<div class="floating-map-button">
  <button class="rui-btn rui-btn--primary" (click)="openMapModal()" style="box-shadow: 4px 4px 0px #ffb612;">
    <i class="fas fa-map"></i>
  </button>
</div>


<router-outlet></router-outlet>